import { render } from "./OrthoDentalArch.vue?vue&type=template&id=0a1487b6&scoped=true"
import script from "./OrthoDentalArch.vue?vue&type=script&lang=js"
export * from "./OrthoDentalArch.vue?vue&type=script&lang=js"

import "./OrthoDentalArch.vue?vue&type=style&index=0&id=0a1487b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1487b6"]])

export default __exports__